<template>
  <div :id="'question-submission-' + interaction.id" class="embed-wrapper">
    <iframe
    :key='iframeKey'
    ref='qIframe'
    class="embedded-iframe"
    width="100%"
    height="100%"
    :src="decodedUrl"
    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"></iframe>
  </div>
</template>

<script>
/* global _ */
/* global dataLayer */
import PlayerService from '@/services/PlayerService';
import EventBus from '@/buses/EventBus';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'interaction-embed',
  props: [
    'interactionId',
    'visible',
  ],
  data() {
    return {
      iframeKey: 0,
      initial: false
    }
  },
  computed: {
    ...mapState('player', [
      'isLiveSession',
      'liveSessionTimeArray',
      'liveSessionUnixTime',
    ]),
    ...mapGetters('player', [
      'bulbAttempt',
      'user',
      'userAgent',
    ]),
    decodedUrl() {
      // Chrome, Edge, and Safari won't display embedded PDFs so we have to use the Google Drive PDF viewer
      const url = decodeURIComponent(this.interaction.interactionText);
      const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      if (url.includes('.pdf') && ['Chrome', 'Edge', 'Safari'].includes(_.get(this, 'userAgent.browser.name'))) {
        return `https://drive.google.com/viewerng/viewer?embedded=true&url=${url}`;
      }
      if (url.includes('app.sli.do')) {
        return `${url}?user_name=${this.user.firstName}${emailRegex.test(this.user.email) ? `&user_email=${this.user.email}` : ''}`;
      }
      return url;
    },
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionCountdown() {
      if (this.isLiveSession) return Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime);
      return 0;
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
    sessionInteraction() {
      return _.find(this.liveSessionTimeArray, { 'interactionId': this.interaction.id });
    }
  },
  methods: {
    ...mapActions('interactions', [
      'submitAnswer'
    ]),

    initAnswer(isRetake) {
      this.interactionAttempt.responseText = ['iframe_placeholder'];
    }
  },
  watch: {
    'visible'() {
      if (
        this.visible
        && !this.interactionMeta.isInteractionAnswered
        && !this.isLiveSession
      ) {
        this.initAnswer();
        this.submitAnswer({interaction: this.interaction, interactionAttempt: this.interactionAttempt, interactionMeta: this.interactionMeta});
      }
      /*
        phet/physnav sites are interactive applications that attempt to get the width of their parent when loaded,
        however since we hide the interaction until it displays, the width can not be grabbed until the
        interaction is visible.  So once visible we refresh the iframe to correctly load.
      */
      if (
        this.visible
        && (
          this.decodedUrl.includes('phet.colorado.edu')
          || this.decodedUrl.includes('physnav.org')
          || this.decodedUrl.includes('.pdf')
          || this.decodedUrl.includes('h5p.com')
        )
      ) {
        this.iframeKey += 1;
      }
    },
    'interactionCountdown'(n) {
      /*
        Web embed interactions cause the video to pause in a normal bulb.  They are also answered as soon as they are visible.
        In a liseSession we wait to submit and mark the interaction answered until the interactionDuration counts down
        Web embeds do not have an interactionOffset - so once we submit, we trigger a play to continue session playback.
      */
      if (
        this.isLiveSession
        && n < 0
        && this.visible
        && !this.interactionMeta.isInteractionAnswered
      ) {
        this.initAnswer();
        this.submitAnswer({interaction: this.interaction, interactionAttempt: this.interactionAttempt, interactionMeta: this.interactionMeta})
        .then(() => {
          EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
        });
      }
    },
  },
};
</script>
